import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";

if (import.meta.env.DEV ) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}

import("./main.app.ui").then(({ initUI }) => {
  initUI();
});

// Skip loading main.app.ts when on base route (microsite mode)
const isBaseRoute = window.location.pathname === "/" ;
if (!isBaseRoute) {
  emitter.on("ui-ready", () => {
    import("./main.app").then(({ initApp }) => {
      initApp();
    });
  });
}

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://efc4b0b4d25c5c92a40e50748477699a@o1388406.ingest.us.sentry.io/4510394097467392",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}